import axios from "axios";
import { API_URL } from "../constants/config";
import { getMemoryToken, clearMemoryToken } from "./tokenStore";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getMemoryToken();
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);
axiosInstance.interceptors.response.use(
  (response) => {
    console.log(response);
    return response;
  },
  (error) => {
    console.log(error.response.response);
    if (error.response?.status === 401) {
      toast.error("Session expired. Please login again.");

      // ✅ Clear token from memory + localStorage
      clearMemoryToken();
      localStorage.removeItem("accessToken");

      // ✅ Redirect to login page
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
